document.addEventListener('DOMContentLoaded', () => {
  const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'];
  const STORAGE_KEY = 'norrbody_utm';

  function readStoredUtm() {
    try {
      const raw = window.sessionStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : {};
    } catch (e) {
      return {};
    }
  }

  function captureUtmFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const found = {};
    let hasAny = false;
    UTM_KEYS.forEach((key) => {
      const value = params.get(key);
      if (value) {
        found[key] = value;
        hasAny = true;
      }
    });
    if (hasAny) {
      try {
        window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(found));
      } catch (e) {
        /* ignore */
      }
      return found;
    }
    return readStoredUtm();
  }

  const utm = captureUtmFromUrl();
  const utmTagSuffix = Object.keys(utm)
    .map((key) => `${key}:${utm[key]}`)
    .join(',');

  if (utmTagSuffix) {
    document.querySelectorAll('[data-early-access-tags]').forEach((field) => {
      field.value = `${field.value},${utmTagSuffix}`;
    });
  }

  function publish(eventName, payload) {
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      window.Shopify.analytics.publish(eventName, payload || {});
    }
  }

  document.querySelectorAll('[data-early-access-cta]').forEach((cta) => {
    cta.addEventListener('click', () => {
      publish(cta.dataset.earlyAccessCta, { target: cta.getAttribute('href') || '' });
    });
  });

  if ('IntersectionObserver' in window) {
    const seen = new Set();
    const viewObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const eventName = entry.target.dataset.viewEvent;
          if (entry.isIntersecting && eventName && !seen.has(eventName)) {
            seen.add(eventName);
            publish(eventName);
            viewObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.4 }
    );

    document.querySelectorAll('[data-view-event]').forEach((el) => viewObserver.observe(el));
  }
});
